import { ArrowRight } from "lucide-react";
import hardwareImg from "@/assets/hardware-suite.jpg";

/**
 * Sección Hardware. La tienda de equipos se gestionará aparte (otra cara del
 * portal); por ahora solo el bloque informativo con el botón "Visitar tienda".
 */
export function Hardware() {
  return (
    <section id="hardware" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-6">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="reveal">
            <span className="text-xs font-bold uppercase tracking-widest text-primary">Hardware</span>
            <h2 className="text-3xl lg:text-5xl font-bold tracking-tight mt-3 mb-5">
              Equipos certificados, listos para vender.
            </h2>
            <p className="text-muted-foreground text-base lg:text-lg mb-8">
              Una tienda curada de hardware probado, compatible con todo el ecosistema TecoPOS. Conecta, configura y vende en minutos.
            </p>
            <button className="group inline-flex items-center gap-2 px-7 py-4 bg-foreground text-background font-semibold rounded-xl hover:scale-[1.02] active:scale-[0.98] transition-all">
              Visitar tienda
              <ArrowRight className="size-4 group-hover:translate-x-0.5 transition-transform" />
            </button>
          </div>

          <div className="relative reveal">
            <div className="rounded-3xl overflow-hidden border border-black/5 shadow-xl">
              <img
                src={hardwareImg}
                alt="Hardware TecoPOS compatible"
                width={1280}
                height={800}
                loading="lazy"
                className="w-full aspect-[5/4] object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
